import { useRef } from 'react';
import { useStickyHeaderShadow, scrollToAnchor } from './useScrollReveal';
import { useLang } from '@/i18n/LanguageContext';

interface HeaderProps {
  /** Jump to the final CTA and pre-select the given pane. */
  onCtaJump: (pane: 'request' | 'invite') => void;
}

const NAV_LINKS = [
  { key: 'nav.how', href: '#features' },
  { key: 'nav.atlas', href: '#atlas' },
  { key: 'nav.faq', href: '#faq' },
];

export default function Header({ onCtaJump }: HeaderProps) {
  const headerRef = useRef<HTMLElement>(null);
  useStickyHeaderShadow(headerRef);
  const { lang, setLang, t } = useLang();

  const onNavClick = (e: React.MouseEvent, href: string) => {
    e.preventDefault();
    scrollToAnchor(href);
  };

  return (
    <header className="site-header" id="siteHeader" ref={headerRef}>
      <div className="container nav">
        <a className="brand" href="#top" onClick={(e) => onNavClick(e, '#top')}>
          <img src="/images/mindstream_logomark.png" alt="Mindstream" />
          <span>Mindstream</span>
        </a>
        <nav className="nav-links">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={(e) => onNavClick(e, link.href)}>
              {t(link.key)}
            </a>
          ))}
        </nav>
        <div className="nav-spacer" />
        <div className="nav-cta">
          <button
            type="button"
            className="nav-lang"
            onClick={() => setLang(lang === 'zh' ? 'en' : 'zh')}
            aria-label={lang === 'zh' ? 'Switch to English' : '切换到中文'}
          >
            {lang === 'zh' ? 'EN' : '中'}
          </button>
          <a
            href="#cta"
            className="nav-invite"
            onClick={(e) => {
              e.preventDefault();
              onCtaJump('invite');
            }}
          >
            {t('nav.invite')}
          </a>
          <a
            href="#cta"
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              onCtaJump('request');
            }}
          >
            {t('nav.request')}
          </a>
        </div>
      </div>
    </header>
  );
}
